import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import SkillsProgress from '../../components/skills-progress';

class WorkEthics extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      progressValue: 0
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();
    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];

    const lastSurveyId =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1].id
        : 0;

    if (!lastSurveyId) {
      return this.setState({
        loaded: true
      });
    }

    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${lastSurveyId}/`
    ).then(res => {
      const surveyScore = res.body;
      const userScoreQuestions = surveyScore.user_score_question || [];

      const neededQuestion = userScoreQuestions.find(i => i.question === 'Work Ethics');
      const progressValue = neededQuestion ? neededQuestion.median : 0;

      this.setState({
        loaded: true,
        progressValue
      });
    })
      .catch(err => { console.log(err); });
  }

  render() {
    const {
      loaded,
      progressValue
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Your Work Ethic Skills Rating</Title>
        <SkillsProgress
          title="Work Ethic"
          progressValue={progressValue}
        />
        <Text>
          <p>Having a good work ethic indicates that you’re demonstrating a high level of passion in any work that you do. This includes consistently delivering quality work on time, following through on commitments, and being present at all times.<br /><br /></p>
          <p>If you’re also proactive, take initiatives, and/or deliver higher quality work than expected then you’re demonstrating a very strong, and highly desirable, work ethic.<br /><br /></p>
          <p>On the flip side, if you’re not doing your fair share of the work, unprepared for meetings and/or missed deadline then you’re demonstrating a very low level of work ethic.</p>
        </Text>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default WorkEthics;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/work-ethics.js